import React, { Fragment, useState } from "react";
import CoreValuesdetails from "./CoreValues-details";
import Dropdown from "./Dropdown";
import GlowButton from "./GlowButton";
import SquareCard from "./SquareCard";

const HowToApply = () => {
    // 🟢 Track which section is open (null = none)
    const [visibleSection, setVisibleSection] = useState({ 1: false, 2: false, 3: false });

    const toggleSectionVisibility = (sectionIndex) => {
        setVisibleSection((prev) => ({ ...prev, [sectionIndex]: !prev?.[sectionIndex] }));
    };

    const step1 = [
        "Be a legally <span class='font-semibold text-white'>registered business</span> or <span class='font-semibold text-white'>educational institute.</span>",
        "Have <span class='font-semibold text-white'>qualified faculty</span> and a <span class='font-semibold text-white'>structured, well-documented curriculum.</span>",
        "Possess a <span class='font-semibold text-white'>minimum of 1 year of operational history.</span>",
        "Maintain a clean compliance record and adhere to the <span class='font-semibold text-white'>FWPI Code of Ethics.</span>",
    ]
    const step2 = [
        "<span class='font-semibold text-white'>Complete the FWPI Training Provider Application Form.</span>",
        "<span class='font-semibold text-white'>Submit required documents</span> including registration proof, course details, and trainer credentials.",
        "<span class='font-semibold text-white'>FWPI Review & Verification</span> – Our team will evaluate your programs, facilities, and compliance with standards.",
        "<span class='font-semibold text-white'>Pay the Annual Accreditation Fee.</span>",
        "<span class='font-semibold text-white'>Receive your Accreditation Certificate & Digital Badge</span> for official use in branding and promotions.",
    ]

    const step3 = [
        {
            name: "Business Registration Certificate",
            title: "Ethical",
            alt: 'Business',
            path: "/assets/services/3/documents/Business.png",
            description: "Being ethical means acting with fairness and integrity. It ensures trust and credibility in every interaction."
        },
        {
            name: "Course Brochure / Syllabus",
            title: "Authenticity",
            alt: 'Syllabus',
            path: "/assets/services/3/documents/Syllabus.png",
            description: "Being authentic means being true to who you are, without compromise. It builds trust and strengthens connections."
        },
        {
            name: "Trainer Qualification Proofs",
            title: "Responsible",
            alt: 'Personal-Trainer',
            path: "/assets/services/3/documents/Personal-Trainer.png",
            description: "Responsibility means owning your actions and decisions. It creates accountability and fosters respect."
        },
        {
            name: "Photos/Videos of Training Setup",
            title: "Recognition",
            alt: 'Gears',
            path: "/assets/services/3/documents/Gears.png",
            description: "Recognition celebrates contributions and achievements. It motivates individuals and builds stronger communities."
        }
    ]


    return (
        <div className="w-full text-white font-urbanist py-16 px-4 md:px-20">
            <div className="w-full mx-auto text-center flex flex-col justify-center items-center relative">
                {/* STEP 1 */}
                <GlowButton
                    text={"Step 1 - Eligibility Criteria"}
                    clickHandler={() => toggleSectionVisibility(1)}
                    isOpen={visibleSection?.["1"]}
                />
                <div className="top-[48px] left-1/2 transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>

                {visibleSection?.["1"] && (
                    <div className="w-full animate-fade-in-down transition-all duration-700 ease-out">
                        <section
                            className="w-full text-white border-2 sm:w-full sm:h-fit border-[#FFFFFF] rounded-[2.5rem] rounded-tl-xl lg:rounded-[8rem] lg:rounded-tl-lg items-center lg:items-start"
                        >
                            <div className="flex justify-center items-center flex-col py-6 md:py-16">
                                <div className="flex justify-center items-center flex-col w-full mx-auto sm:pb-8 ">
                                    <h2 className="text-3xl md:text-4xl font-semibold mb-2 text-white text-center">
                                        Eligibility Criteria
                                    </h2>
                                    <p className="w-full mx-auto text-xl md:text-[20px] lg:text-[22px] xl:text-[24px]  font-normal text-neutral-400 mb-2 font-urbanist italic tracking-[2%] text-center px-10 lg:px-16 py-2">
                                        To qualify for FWPI accreditation, your institution must
                                    </p>
                                </div>

                                <ul className="lg:w-4/6 list-disc text-left list-outside space-y-6 font-urbanist font-light text-[14px] sm:text-[16px] lg:text-[20px] mx-auto max-w-4xl px-10 lg:px-16">
                                    {
                                        step1.map((item, index) => {
                                            return (
                                                <li key={index} className="text-sm md:text-lg text-neutral-300" dangerouslySetInnerHTML={{ __html: item }}>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </section>

                        <div className="w-full justify-center items-center flex">
                            <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                        </div>
                    </div>
                )}

                {/* STEP 2 */}
                <GlowButton
                    text={"Step 2 - Application Process"}
                    clickHandler={() => toggleSectionVisibility(2)}
                    isOpen={visibleSection?.["2"]}
                />
                <div className="w-full justify-center items-center flex">
                    <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                </div>
                {visibleSection?.['2'] && (
                    <div className="w-full animate-fade-in-down transition-all duration-700 ease-out">
                        <section
                            className="w-full text-white border-2 sm:h-fit border-[#FFFFFF] rounded-[2.5rem] rounded-tr-xl lg:rounded-[8rem] lg:rounded-tr-lg items-center lg:items-start"
                        >
                            {/* Step 2 ke content yahan daalna */}
                            <div className="flex flex-col items-center py-6 md:py-16">
                                <div className="flex justify-center items-center flex-col w-full mx-auto  sm:pb-8 ">
                                    <h2 className="text-3xl md:text-4xl font-semibold mb-2 text-white text-center">
                                        Application Process
                                    </h2>
                                </div>

                                <ul className="lg:w-4/6 list-decimal text-left list-outside space-y-6 font-urbanist font-light text-[14px] sm:text-[16px] lg:text-[20px] mx-auto max-w-4xl px-10 lg:px-16 mt-4">
                                    {
                                        step2.map((item, index) => {
                                            return (
                                                <li key={index} className="text-sm md:text-lg text-neutral-300" dangerouslySetInnerHTML={{ __html: item }}>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </section>
                        <div className="w-full justify-center items-center flex">
                            <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                        </div>
                    </div>
                )}

                {/* STEP 3 */}
                <GlowButton
                    text={"Step 3 - Required Documents"}
                    clickHandler={() => toggleSectionVisibility(3)}
                    isOpen={visibleSection?.["3"]}
                />
                {visibleSection?.["3"] && (
                    <Fragment>
                        <div className="w-full justify-center items-center flex">
                            <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                        </div>
                        <div className="w-full animate-fade-in-down transition-all duration-700 ease-out">
                            <section className="w-full text-white border-2 sm:h-fit border-[#FFFFFF] rounded-[2.5rem] rounded-tl-xl lg:rounded-[8rem] lg:rounded-tl-lg items-center lg:items-start p-6 overflow-hidden">
                                <SquareCard
                                    title={"Required Documents"}
                                    points={step3}
                                    isCurved={true}
                                />
                            </section>
                        </div>
                    </Fragment>
                )}
            </div>
        </div>
    );
};

export default HowToApply;
